import { React, RouteComponentProps, i18n, inject, mui, observer, pr, theme } from "aaa";
import { User } from "models/User";
import { ui } from "util/uiHelpers";

const ThankYou = (props: { name: string }) => (
    <pr.HFlex style={{ alignItems: "center", border: "2px solid #00822C", padding: 10, borderRadius: 8, marginBottom: theme.MARGIN_BIG }}>
        <pr.IconCheckCircle style={{ color: "#00822C", width: 44, height: 44, marginRight: theme.MARGIN }} />
        <div>
            <i18n.FormattedHTMLMessage id="success.thankYou" values={{ name: props.name }} />
        </div>
    </pr.HFlex>
);

type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    user: User
};


@i18n.injectIntl
@inject("user")
@observer
export class SuccessScreen extends React.Component<IProps, {}> {

    componentDidMount() {
        window.scrollTo(0, 0);
        // Allow closing, user is done with the process.
        window.onbeforeunload = () => { /**/ };
    }

    render() {
        return (
            <div style={{ padding: theme.MARGIN_BIG }}>
                <br /><br />
                <ThankYou name={this.props.user.name} />
                <i18n.FormattedHTMLMessage id="success.message" />
                <div style={{ textAlign: "center" }}>
                    <mui.RaisedButton
                        label={ui.__("backToSpardaWebsite")}
                        style={{
                            width: 300,
                            marginTop: theme.MARGIN_BIG,
                        }}
                        primary={true}
                        onClick={() => {
                            window.open("https://www.sparda-hessen.de", "_self");
                        }}
                    />
                </div>
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SuccessScreen.tsx